<template>

    <v-page-section>
        <template #header>
            <span>Basic Info</span>
            <v-identifier :uuid="user.id" />
        </template>
        <template #body>
            <v-form-group label="First Name" caption="Your first name.">
                <v-input class="w-500" :model="params.first_name" @input="params.first_name = $event" />
            </v-form-group>
            <v-form-group label="Last Name" caption="Your last name.">
                <v-input class="w-500" :model="params.last_name" @input="params.last_name = $event" />
            </v-form-group>
            <v-form-group label="Email Address" caption="Your email address.">
                <v-input class="w-500" type="email" :model="params.email" @input="params.email = $event" />
                <v-button v-if="!user.verified_at" class="mt-10" size="xs" btn-style="white-danger" @click.native="$store.commit('showModal', 'verify-email')">Verify Email Address</v-button>
            </v-form-group>
            <v-form-group label="Timezone" caption="Your timezone.">
                <v-timezone-picker class="w-500" :model="params.timezone" @input="params.timezone = $event" />
            </v-form-group>
            <v-form-group label="Chat Widget" caption="Hide or show the chat widget in the corner.">
                <v-select class="w-400" :model="params.has_chat_widget" @input="params.has_chat_widget = $event">
                    <option :value="true">Show Chat Widget</option>
                    <option :value="false">Hide Chat Widget</option>
                </v-select>
            </v-form-group>
        </template>
        <template #footer>
            <v-button size="sm" :loading="loading" @click.native="updateUser">Save</v-button>
        </template>
    </v-page-section>

</template>

<script>

import UserApi from '@api/UserApi';

export default {

    data() {
        return {
            loading: false,
            params: {},
        }
    },

    computed: {

        user() {
            return this.$store.getters.user;
        },

    },

    mounted() {
        this.params = {
            first_name: this.user.first_name,
            last_name: this.user.last_name,
            email: this.user.email,
            timezone: this.user.timezone,
            has_chat_widget: this.user.has_chat_widget,
        };
    },

    methods: {

        updateUser() {
            this.loading = true;
            UserApi.updateUser(this.params)
                .then((response) => {
                    this.loading = false;
                    this.$store.commit('setAlertSuccess', this.$t('message.saved'));
                }, (error) => {
                    this.loading = false;
                    this.$store.commit('setAlertWithError', error);
                });
        },

    },

}

</script>
